import { createAction } from '@reduxjs/toolkit';

export const logOut = createAction<void>('auth/logout');
